// Ponte verso il browser interno di MetaMask (decisione GP 23/08).
//
// PERCHE' SERVE: il checkout crypto firma con il wallet INIETTATO nella pagina
// (window.ethereum, vedi approveAndMint.jsx) — niente WalletConnect. Su un
// telefono, Safari/Chrome non iniettano nulla: l'unico browser dove il mint
// puo' avvenire e' quello dentro l'app MetaMask. Finora l'utente da telefono
// leggeva "installa l'estensione", istruzione impossibile da eseguire su iOS.
//
// FORMATO: https://link.metamask.io/dapp/<url senza schema> — verificato dal
// vivo il 23/08/2026 (il vecchio metamask.app.link risponde identico). Senza
// MetaMask installato l'indirizzo porta allo store, non a un vicolo cieco.
//
// SICUREZZA: la base e' FISSA e l'URL di destinazione lo costruiamo NOI dai
// nostri domini — non arriva mai da un input esterno. Un indirizzo di terzi
// qui dentro sarebbe un reindirizzamento aperto travestito da wallet.

export const METAMASK_DEEPLINK_BASE = "https://link.metamask.io/dapp/";
// Schema diretto dell'app (metamask://dapp/<host+path>, da
// MetaMask/metamask-mobile app/constants/deeplinks.ts). Serve quando la pagina
// gira dentro una PWA installata: lì un indirizzo esterno apre una finestra di
// browser sovrapposta che, passata la mano a MetaMask, resta VUOTA a schermo
// (segnalato da GP il 23/08). Lo schema diretto lo prende il sistema.
export const METAMASK_APP_SCHEME = "metamask://dapp/";

/** Telefono/tablet: l'unico contesto dove il browser di MetaMask ha senso.
 *  Su desktop l'estensione esiste, quindi "installa l'estensione" resta il
 *  consiglio giusto. */
export function isMobileBrowser() {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Mobile|Silk/i.test(navigator.userAgent || "");
}

/** Il wallet manca E siamo dove non potrebbe esserci un'estensione.
 *  Nota: dentro il browser di MetaMask window.ethereum ESISTE, quindi questa
 *  torna false — nessun anello di rimbalzi su se stesso. */
export function needsMetaMaskBrowser() {
  if (typeof window === "undefined") return false;
  return isMobileBrowser() && !window.ethereum;
}

/** PWA installata: nessuna barra del browser, ogni uscita apre una finestra
 *  sovrapposta che dopo il passaggio a MetaMask resta vuota. */
export function isStandaloneApp() {
  if (typeof window === "undefined") return false;
  return (
    window.navigator?.standalone === true ||
    (typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches)
  );
}

/** URL assoluto dei NOSTRI domini -> link universale che apre il browser di
 *  MetaMask su quella pagina (o lo store, se l'app non c'e'). Ritorna null se
 *  l'URL non e' assoluto http(s): meglio nessun pulsante che un pulsante che
 *  porta chissa' dove. */
export function metaMaskDeepLink(absoluteUrl) {
  const url = String(absoluteUrl || "");
  const m = url.match(/^https?:\/\/(.+)$/i);
  return m ? `${METAMASK_DEEPLINK_BASE}${m[1]}` : null;
}

/** Porta l'utente in MetaMask. Dentro la PWA installata prova lo schema
 *  diretto (non lascia finestre vuote) con ripiego sul link universale dopo
 *  un attimo, per chi MetaMask non ce l'ha. Vedi il gemello in app/. */
export function openInMetaMask(absoluteUrl) {
  const universale = metaMaskDeepLink(absoluteUrl);
  if (!universale) return false;
  if (!isStandaloneApp()) {
    window.location.href = universale;
    return true;
  }
  const m = String(absoluteUrl).match(/^https?:\/\/(.+)$/i);
  let uscito = false;
  const segnaUscita = () => {
    uscito = true;
  };
  document.addEventListener("visibilitychange", segnaUscita);
  // Terza cintura: se il sistema congela la pagina senza far scattare
  // visibilitychange, `pagehide` marca comunque l'uscita — senza, al ritorno
  // il timer differito porterebbe via l'utente da solo.
  window.addEventListener("pagehide", segnaUscita);
  window.location.href = `${METAMASK_APP_SCHEME}${m[1]}`;
  setTimeout(() => {
    document.removeEventListener("visibilitychange", segnaUscita);
    window.removeEventListener("pagehide", segnaUscita);
    if (!uscito && !document.hidden) window.location.href = universale;
  }, 1500);
  return true;
}
